export default __webpack_public_path__ + "static/media/news86.9443e3d1.jpg";